import type { ReactNode } from "react";
import { useShowcaseMode } from "@/lib/showcase/showcaseMode";

/**
 * Wraps showcase content with stream-safe framing:
 * - 16:9 safe gutters reserved for stream overlays
 * - Lower-third area at the bottom for the active brand/influencer
 * Only active when creatorMode is on.
 */
export function CreatorCameraFrame({
  children,
  lowerThird,
}: { children: ReactNode; lowerThird?: ReactNode }) {
  const s = useShowcaseMode();
  if (!s.creatorMode) return <>{children}</>;

  return (
    <div className="relative">
      {/* safe zone gutters (visual only) */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 rounded-3xl"
        style={{
          boxShadow: "inset 0 0 0 1px oklch(0.7 0 0 / 0.08), inset 0 0 80px oklch(0 0 0 / 0.35)",
        }}
      />
      <div className="px-2 md:px-4">{children}</div>
      {lowerThird && (
        <div className="pointer-events-none sticky bottom-2 mt-3 flex justify-start">
          <div className="pointer-events-auto rounded-r-2xl border border-l-0 border-border/60 bg-background/85 px-3 py-2 backdrop-blur">
            {lowerThird}
          </div>
        </div>
      )}
    </div>
  );
}
